export default __webpack_public_path__ + "static/media/logo-alt.b55b007f.png";